
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacInput from '@/components/BacInput.vue'
import BacEditableImage from '@/components/BacEditableImage.vue'
import BacButton from '@/components/BacButton.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'

import { User } from '@/lib/models/User'

import { ToggleButton } from 'vue-js-toggle-button'

import { parsePhoneNumber } from 'libphonenumber-js'
import UIkit from 'uikit'
import { Http } from '@/lib/utils/Http'
import { Country } from '../lib/models/Country'

import ChangePasswordModal from '@/components/customer/ChangePasswordModal.vue'

@Component({
  components: {
    BacInput,
    BacEditableImage,
    BacButton,
    VuePhoneNumberInput,
    ToggleButton,
    ChangePasswordModal
  }
})
export default class Customer extends Vue {
  profilePicturePath = ''

  phone: any = {}
  phoneNumberInputModel = '';
  defaultCountry = 'AT';

  countries: Country[] = []

  @Watch('phone')
  public onPhoneChanged () {
    this.user.telephone = this.phone.formatInternational
  }

  get status () {
    return !!this.user.status
  }

  set status (value) {
    this.user.status = value ? 1 : 0
  }

  get birthday () {
    const date = new Date(this.user.birthday)
    if (this.user.birthday && date instanceof Date && isFinite(date as any)) {
      return date.toISOString().split('T')[0]
    } else {
      return new Date('01/02/1970').toISOString().split('T')[0]
    }
  }

  set birthday (birthday: string) {
    this.user.birthday = birthday
  }

  get user () {
    return this.$store.state.LoggedInUser.user
  }

  get customerGroups () {
    return User.customerGroups
  }

  get userPhoneNumber () {
    return (parsePhoneNumber as any)(this.user.telephone, { defaultCountry: 'AT' })
  }

  profilePictureSuccessfullChange () {
    this.$store.dispatch('loadLoggedInUser')
  }

  async updateProfilePicture () {
    if (!this.user.picture) {
      this.profilePicturePath = require('@/assets/img/icons/default-profile-picture.jpg')
      return
    }
    this.profilePicturePath = this.user.picture
  }

  @Watch('user')
  public onUserChange () {
    this.phoneNumberInputModel = this.userPhoneNumber.nationalNumber
    this.defaultCountry = this.userPhoneNumber.country
    this.status = this.user.status === 1
    this.updateProfilePicture()
  }

  mounted () {
    this.$store.dispatch('loadLoggedInUser')
    this.updateProfilePicture()
    this.loadCountries()
  }

  async loadCountries () {
    this.countries = await Country.getAll({})
  }

  async save () {
    this.user.email = this.user.email.trim()

    const res = await Http.request(`/api/user/${this.user.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(this.user)
    })
    if (res.status === 200) {
      UIkit.notification({
        message: 'Profil erfolgreich gespeichert!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    } else if (res.status === 400) {
      const data = await res.json()
      if (data.error === 'email-already-exists') {
        UIkit.notification({
          message: 'Ein Konto mit dieser E-Mail Adresse existiert bereits!',
          status: 'warning',
          timeout: 5000,
          pos: 'bottom-center'
        })
        this.$store.dispatch('loadLoggedInUser')
      }
    } else {
      UIkit.notification({
        message:
          'Etwas ist beim Speichern des Profils schief gelaufen, bitte kontaktiere uns unter hello@backroadclub.com!',
        status: 'warning',
        timeout: 5000,
        pos: 'bottom-center'
      })
    }
  }
}
